import React from 'react';
import { useTranslation } from 'react-i18next';
import NativeDropdown from '../../../../Dropdown2/NativeDropdown';
import { BiEventType } from '../../../../biLogger/constants';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../_partials/hooks/useDeviationAttributes';
import s from './MoreMenuMobileDropdown.scss';
var MoreMenuMobileDropdown = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, showReportModal = _a.showReportModal, showMobileDeviationSharePopup = _a.showMobileDeviationSharePopup, showMobileAddToGroupsPanel = _a.showMobileAddToGroupsPanel;
    var t = useTranslation().t;
    var _b = useDeviationAttributes(deviation, isOwner), isShareable = _b.isShareable, isGroupSubmittable = _b.isGroupSubmittable, isReportable = _b.isReportable;
    var onSelect = function (value) {
        switch (value) {
            case 'share':
                showMobileDeviationSharePopup(deviation);
                break;
            case 'addToGroup':
                showMobileAddToGroupsPanel(deviation);
                break;
            case 'report':
                showReportModal(deviation);
                break;
            default:
        }
    };
    return (React.createElement(NativeDropdown, { className: s['root'], onSelect: onSelect, items: [
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: {
                    evid: BiEventType.CLICK_SHARE,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                },
            },
            isGroupSubmittable && {
                value: 'addToGroup',
                label: t('actionbar.addToGroup'),
                biData: {
                    evid: BiEventType.ADD_TO_GROUP_CLICK,
                    deviationid: deviation.deviationId,
                },
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: {
                    evid: BiEventType.CLICK_REPORT_BUTTON,
                    modal_version: 2,
                },
            },
        ] }));
};
MoreMenuMobileDropdown.displayName = 'MoreMenuMobileDropdown';
export default MoreMenuMobileDropdown;
//# sourceMappingURL=MoreMenuMobileDropdown.js.map